// src/security/sessionUser.js

const SESSION_KEY = 'sigmaUser';

const DEFAULT_TIMEOUT_MINS = 5; // Valor por defecto de 5 minutos

export function setSessionUser({ idUsuario, nombreUsuario, idEmpresa, idPerfil, minutosInactividad, xsrfToken }) {
  if (!idUsuario || !nombreUsuario) {
    console.warn('setSessionUser llamado sin idUsuario o nombreUsuario', {
      idUsuario,
      nombreUsuario,
    });
  }

  const payload = {
    idUsuario,
    nombreUsuario,
    idEmpresa,
    idPerfil,
    xsrfToken,
    minutosInactividad: minutosInactividad || DEFAULT_TIMEOUT_MINS
  };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));
}

// getSessionToken() eliminado: el token ahora es HttpOnly (FASE 4)

export function getSessionUser() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.error('Error leyendo sessionUser', err);
    return null;
  }
}

export function getSessionUserId() {
  const u = getSessionUser();
  return u?.idUsuario ?? null;
}

export function getSessionUserName() {
  const u = getSessionUser();
  return u?.nombreUsuario ?? '';
}

export function getSessionEmpresaId() {
  const u = getSessionUser();
  return u?.idEmpresa ?? null;
}

export function getSessionPerfilId() {
  const u = getSessionUser();
  return u?.idPerfil ?? null;
}

export function getSessionTimeoutMinutos() {
  const u = getSessionUser();
  return u?.minutosInactividad ?? DEFAULT_TIMEOUT_MINS;
}

export function getSessionXsrfToken() {
  const u = getSessionUser();
  return u?.xsrfToken ?? null;
}

export function isSessionSuperAdmin() {
  const u = getSessionUser();
  // Un SuperAdmin es aquel con IdPerfil 1 O que no tiene empresa asociada
  return u?.idPerfil === 1 || !u?.idEmpresa || u?.idEmpresa === 0 || u?.idEmpresa === '0';
}

export function clearSessionUser() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function updateSessionTimeout(minutos) {
  const u = getSessionUser();
  if (u) {
    u.minutosInactividad = minutos;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(u));
  }
}
